/// <amd-module name="Build/Extensions/GitHubEnterprise/RepositorySelection" />
import { Props, RepositorySelection as GitHubRepositorySelection } from "Build/Extensions/GitHub/RepositorySelection";

import { IVssComponentContext } from "VSS/Platform/Layout";

export class RepositorySelection extends GitHubRepositorySelection {
  constructor(props: Props, context: IVssComponentContext) {
    super(props, context);
  }

  protected autoSelectConnection(): boolean {
    return false;
  }
}